import { createEntity } from "metabase/lib/entities";

export default createEntity({
  name: "tasks",
  path: "/api/task",
});
